module.exports = __webpack_public_path__ + "img/asia_swift.6c15f318.svg";